/** Component - EmptyState and Skeleton.dc.html: rule, headline, one sentence, one button. */
export function EmptyState({
  title,
  body,
  actionLabel,
  onAction,
  secondary,
}: {
  title: string;
  body: string;
  actionLabel?: string;
  onAction?: () => void;
  secondary?: React.ReactNode;
}): JSX.Element {
  return (
    <div className="flex flex-col gap-4 px-6 py-10" data-testid="empty-state">
      <div className="w-12 border-t-2 border-fg" />
      <h3 className="text-xl font-bold tracking-tight text-fg">{title}</h3>
      <p className="text-sm leading-relaxed text-fg-2">{body}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="self-start rounded-md bg-inverse px-5 py-3 text-sm font-semibold text-inverse-fg"
        >
          {actionLabel}
        </button>
      )}
      {secondary}
    </div>
  );
}

export function ListRowSkeleton(): JSX.Element {
  return (
    <div
      className="flex flex-col gap-4 rounded-md border border-line bg-surface p-4"
      data-testid="list-skeleton"
    >
      {[0, 1, 2].map((i) => (
        <div key={i} className="flex items-center gap-3">
          <span className="h-5 w-5 flex-shrink-0 animate-pulse rounded bg-raised" />
          <span
            className="h-4 flex-1 animate-pulse rounded bg-raised"
            style={{ animationDelay: `${i * 0.1}s` }}
          />
        </div>
      ))}
    </div>
  );
}
